import { useQuery, defineQuery, defineQueryOptions } from '@pinia/colada';
import { featureFlagKeys } from './keys';
import { staleTimes } from '../stale-times';
import { fetchFeatureFlags } from 'src/services/feature-flags';

export const featureFlagsQuery = defineQueryOptions({
  key: featureFlagKeys.all,
  query: fetchFeatureFlags,
  staleTime: staleTimes.medium,
});

export const useFetchFeatureFlagsQuery = defineQuery(() => {
  return useQuery(featureFlagsQuery);
});
